/* custom-contact-modal.js — the "Send us a message" dialog on the Contact page
 *
 * The Email tile used to be a bare mailto:. On a desktop with no mail client
 * configured that click does nothing whatsoever, with no feedback — the tile
 * looked broken. It now opens the contact form in a dialog.
 *
 * Progressive enhancement. The tile is a real <a href="#gfc-contact-modal">, and
 * the section's CSS reveals the dialog on :target, so it still opens with this
 * file missing or broken. Everything here is the upgrade: Esc, scrim click,
 * scroll lock, focus move and focus restore.
 *
 * The form posts to Shopify and the browser navigates. Shopify sends the page
 * back with ?contact_posted=true, at which point the dialog has to reopen so the
 * sender actually sees the confirmation instead of landing back on a closed
 * dialog wondering whether it sent. There is no way to tell from the reloaded
 * page WHICH of the two contact forms was submitted, so the dialog records that
 * it was the sender in sessionStorage just before it submits, and clears it on
 * the way back. Without that, submitting the form at the bottom of the page
 * would also pop the dialog open.
 */
(function () {
  'use strict';

  var FLAG = 'goat:contact-modal-sent';
  var modal, panel, form;
  var lastFocused = null;

  // The section renders this script tag above its own markup, so at parse time
  // the dialog does not exist yet. Looking it up immediately found nothing and
  // the whole file returned early — the tile still opened the dialog through the
  // :target fallback, which is exactly why it looked like it was working while
  // Esc, the scrim, focus and the scroll lock all quietly did nothing.
  function init() {
    modal = document.getElementById('gfc-contact-modal');
    if (!modal) return;
    panel = modal.querySelector('.gfc-modal__panel');
    form = modal.querySelector('form');
    wire();
    restoreAfterSubmit();
  }

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  function open(ev) {
    if (ev) ev.preventDefault();
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    document.body.classList.add('gfc-modal-open');
    // The success or error note matters more than the first field when there is
    // one, so it gets focus and screen readers announce it.
    var note = panel.querySelector('.gfc-modal__ok, .gfc-modal__err');
    var first = note || panel.querySelector('#GfcModal-email') || focusables()[0];
    if (first) first.focus();
  }

  function close(ev) {
    if (ev) ev.preventDefault();
    modal.classList.remove('is-open');
    document.body.classList.remove('gfc-modal-open');
    // Clear the :target fallback too, or the dialog springs back open on the
    // next render because the URL still ends in #gfc-contact-modal.
    if (window.location.hash === '#gfc-contact-modal') {
      try { history.replaceState({}, '', window.location.pathname + window.location.search); } catch (e) { /* ignore */ }
    }
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }

  function wire() {
    document.addEventListener('click', function (ev) {
      var opener = ev.target.closest ? ev.target.closest('[data-gfc-modal-open]') : null;
      if (opener) {
        if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button) return;
        open(ev);
        return;
      }
      if (ev.target.closest && ev.target.closest('[data-gfc-modal-close], .gfc-modal__scrim')) close(ev);
    });

    document.addEventListener('keydown', function (ev) {
      if (!modal.classList.contains('is-open')) return;
      if (ev.key === 'Escape') { close(ev); return; }
      if (ev.key !== 'Tab') return;
      // Keep tabbing inside the dialog while it is open.
      var items = focusables();
      if (!items.length) return;
      var firstEl = items[0];
      var lastEl = items[items.length - 1];
      if (ev.shiftKey && document.activeElement === firstEl) { ev.preventDefault(); lastEl.focus(); }
      else if (!ev.shiftKey && document.activeElement === lastEl) { ev.preventDefault(); firstEl.focus(); }
    });

    if (form) {
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem(FLAG, '1'); } catch (e) { /* private mode */ }
      });
    }
  }

  // Coming back from a submit, or landing on the #gfc-contact-modal link.
  function restoreAfterSubmit() {
    var params = new URLSearchParams(window.location.search);
    var sent = false;
    try { sent = sessionStorage.getItem(FLAG) === '1'; } catch (e) { /* ignore */ }
    if (params.get('contact_posted') === 'true' && sent) {
      try { sessionStorage.removeItem(FLAG); } catch (e) { /* ignore */ }
      open();
    } else if (window.location.hash === '#gfc-contact-modal') {
      open();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
